// Who holds copyright in the retellings, and the two notices that say so — the
// persistent reader footer and the note appended to copied prose (SPEC
// "Copyright protections").
//
// One module rather than three string literals: the footer was duplicated
// verbatim between `reading-view` and `matter-view`, the copy note said much
// the same thing a third time, and the rightsholder is exactly the kind of
// value that gets changed in two places out of three.

/** The rightsholder named in every copyright notice the app prints. */
export const COPYRIGHT_HOLDER = "Russ T. Fugal";

/**
 * The persistent footer notice. The year is read at call time rather than
 * pinned: the notice is a live statement about the current year, and both
 * callers already re-render often enough that a cached value would be the
 * surprising choice.
 */
export function copyrightNotice(bookTitle: string): string {
  const year = new Date().getFullYear();
  return (
    `“${bookTitle}”, a retelling — © ${String(year)} ${COPYRIGHT_HOLDER}. ` +
    `Original text in the public domain.`
  );
}

/**
 * The sourcing note appended to copied retelling prose. Takes the retrieval URL
 * rather than reading `window` itself, so it can be built off the DOM. Like
 * `copyrightNotice` it still reads the clock — deliberately, for the same
 * reason — so it is not a pure function.
 */
export function sourcingNote(bookTitle: string, url: string): string {
  const year = new Date().getFullYear();
  return (
    `\n\n— from “${bookTitle}”, a retelling. ` +
    `© ${String(year)} ${COPYRIGHT_HOLDER}. Retrieved from ${url}. ` +
    `The retelling is an original work; the underlying classic is in the public domain.`
  );
}
